import styled, { css } from "styled-components";
import { px2rem } from "../../../utils/css";
import { PriceViewsLayout } from "./index";

export const InfoViewGridBase = styled.section`
	display: flex;
	flex-direction: column;
`;

export const InfoViewGrid2 = styled(InfoViewGridBase)`
	display: flex;
	flex-direction: column;
	padding: 0 0.625rem;
	> * {
		&:first-child {
			flex: 1 auto;
		}
	}
`;
export const InfoViewGrid1 = styled(InfoViewGridBase)`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 0.5rem 0.5rem 0.15rem;
	position: relative;
	justify-content: space-between;
`;

export const NameView = styled.p`
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	color: #333;

	${({ gridCol, fixedCol }: { gridCol: number; fixedCol?: number }) => {
		switch (gridCol) {
			case 1:
				return css`
					font-size: 0.875rem;
					font-weight: 400;
					line-height: 1.125rem;
					-webkit-line-clamp: ${fixedCol ? fixedCol : 2};
					min-height: ${fixedCol ? 0 : "2.25rem"};
				`;
			case 2:
				return css`
					width: 100%;
					margin-top: 0.5rem;
					-webkit-line-clamp: ${fixedCol ? fixedCol : 2};
					font-size: 0.75rem;
					font-weight: 400;
					min-height: ${fixedCol ? 0 : "2.1rem"};
					line-height: 1.06rem;
				`;
			default:
				return "";
		}
	}}
`;
export const NameViewWithTag = styled.img`
	position: relative;
	top: 0.125rem;
	height: 0.75rem;
	margin-top: 0.0625rem;
	margin-right: 0.125rem;
`;

interface PriceViewProps extends PriceViewsLayout {
	gridCol: number;
}
export const PriceView = styled.p`
	display: flex;
	text-overflow: ellipsis;
	flex-direction: ${({ hasLineBreak }: PriceViewProps) => (hasLineBreak ? "column" : "row")};

	.price {
		font-weight: 600;
		font-family: var(--fontBold);
		color: var(--priceFontColor);
		white-space: nowrap;
	}

	${(props: PriceViewProps) => {
		switch (props.gridCol) {
			case 1:
				return css`
					margin: ${px2rem(10)} 0 0;
					font-size: 1rem;
					line-height: 1rem;
				`;
			case 2:
				return css`
					margin: 0.25rem 0 0.09rem 0;
					display: flex;
					font-size: 0.875rem;
					line-height: 1.1875rem;
					align-items: ${props.hasLineBreak ? "inherit" : "center"};
				`;
			case 3:
				return css`
					padding: 0.5rem;
					font-size: 0.875rem;
					line-height: 1.1875rem;
					text-align: left;
					justify-content: center;
				`;
			default:
				return "";
		}
	}}
`;

export const OriginalPriceView = styled.p`
	color: #999;
	font-size: 0.75rem;
	line-height: 1.0625rem;
	text-decoration: line-through;
	font-weight: 400;
	text-overflow: ellipsis;
	overflow: hidden;
	margin-left: ${({ hasLineBreak }: Pick<PriceViewProps, "hasLineBreak">) =>
		hasLineBreak ? "inherit" : "0.25rem"};
`;

export const CollectViewOrange = styled.span`
	font-weight: 400;
	font-size: 0.75rem;
	line-height: 0.875rem;
	color: #999;
`;
export const InfoBottomStyle2 = styled.section`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 0 0.25rem;
	${(props: { gridCol: number }) => {
		switch (props.gridCol) {
			case 1:
				return css`
					margin-top: 0.375rem;
				`;
			case 2:
				return css`
					width: 100%;
				`;
			default:
				return "";
		}
	}}
`;

export const InfoBottomLeftText = styled.span`
	color: #999;
	font-weight: 400;
	font-size: 0.75rem;
	line-height: 0.875rem;
`;

export const ShipTo24HoursBox = styled.div`
	font-size: 0.75rem;
	color: #666;
`;

export const ActTagViewForMGrid = styled.section`
	margin-top: 0.25rem;
	display: flex;
	gap: 0.25rem;
	img {
		display: block;
		height: 0.875rem;
		width: auto;
		object-fit: cover;
	}
`;

export const ScoreTextView = styled.span`
	color: #999;
	font-size: ${px2rem(12)};
	margin-left: 3px;
	line-height: 0;
	padding-top: 1px;
`;
